<template>
  <div class="app-header">
    <div class="container max-w">
      <div style="z-index: 999; margin-right: 40px;">
        <el-image style="width: 120px; height: 120px" :src="url" fit="cover"></el-image>
      </div>
      <div>
        <el-menu :default-active="this.$route.path" router class="el-menu-demo" mode="horizontal" menu-trigger="click" @select="handleSelect" background-color="#ffffff" text-color="#1E50AE" active-text-color="#1E50AE" :collapse-transition="false">
          <el-menu-item index="/">首页</el-menu-item>
          <el-submenu index="about" class="custom-menu">
            <template slot="title">关于盛世行</template>
            <el-menu-item index="/about">
              <div class="menu-item-title">
                <img src="../assets/img/menu_active.svg" alt="" class="menu-item-icon">
                <div>公司简介</div>
              </div>
            </el-menu-item>
            <el-menu-item index="/corporateCulture">
              <div class="menu-item-title">
                <img src="../assets/img/menu_active.svg" alt="" class="menu-item-icon">
                <div>企业文化</div>
              </div>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="/productDisplay">产品展示</el-menu-item>
          <el-menu-item index="/recruit">人才招聘</el-menu-item>
          <el-menu-item index="/contact">联系我们</el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: require('../assets/img/logo.png'),
      activeIndex2: '/',
    }
  },
  watch: {
    $route() {
      this.setCurrentRoute()
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key
      console.log(key, keyPath);
    },
    setCurrentRoute() {
      this.activeIndex = this.$route.name;//关键   通过他就可以监听到当前路由状态并激活当前菜单
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-item-title {
  position: relative;
  margin: 0 -10px;
  .menu-item-icon {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    display: none;
    margin-right: 22px;
    width: 12px;
    height: 13px;
  }
  padding-left: 34px;
}
 .el-menu-item.is-active {
  .menu-item-title {
    background-color: #e3eaf9;
    .menu-item-icon {
      display: block;
    }
  }
}
.app-header {
  height: 60px;
  .container {
    display: flex;
    margin: 0 auto;
  }

  .el-menu.el-menu--horizontal {
    border: none !important;
  }
  .el-submenu .el-menu-item__submenu {
    background-color: red !important; /* 替换为你想设的背景颜色，如 rgba(0, 0, 0, 0.1) 或者 '#f5f5f5' */
  }
  ::v-deep .el-menu-item:hover,
  ::v-deep .el-submenu__title:hover {
    background-color: transparent !important;
  }

  // ::v-deep .el-menu.el-menu--horizontal.el-menu-item:not(.is-disabled):hover {
  //   background-color: #144eca !important;
  // }

  ::v-deep .el-submenu__title {
    background-color: transparent !important;
  }
  ::v-deep .el-menu-item {
    transition: none !important;
  }
  ::v-deep .el-menu-item:hover {
    background-color: #ecf5ff !important;
  }
  ::v-deep .el-submenu__title {
    transition: none !important;
  }
  ::v-deep .el-menu-item.is-active,
  ::v-deep .el-submenu.is-active {
    color: #1e50ae;
    font-weight: bold;
    background: linear-gradient(
      41deg,
      #f6faff 0%,
      #e6eeff 61%,
      #dce7ff 100%
    ) !important;
    border-radius: 10px 10px 0px 0px;
    border-bottom: none !important;
    text-decoration: none !important;
  }

  ::v-deep .el-submenu.is-active .el-submenu__title {
    border: none !important ;
  }
}
</style>